
module.exports = {
    myHost: {
       'host':'https://api.fairdhaka.com/api'
    }
};
